<template>
    <div class="CourseSingupModalWarp">
        <!-- 显示报名 -->
        <el-dialog title="" :visible.sync="showFileVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">

                <div class="stepsBox">
                    <el-steps :active="active" align-center>
                        <el-step title="填写报名信息"></el-step>
                        <el-step title="完善报名信息"></el-step>
                        <el-step title="上传文件"></el-step>
                    </el-steps>
                </div>
                <div v-if="!flag">
                    <div class="textbox">
                        <!-- <span>查看</span>下载领军人才学员选拔表
                        <i class="el-icon-download iconbox" /> -->
                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                            <span>《选拔表》</span>
                        </div>
                        <div class="downBox" @click="downloadRecommendFn">下载</div>
                    </div>
                    <div class="textbox">
                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                            <span>《推荐信》</span>
                        </div>
                        <div class="downBox" @click="downloadFileFn">下载</div>
                    </div>
                    <div class="singupForm">
                        <el-form :model="formData" ref="formData" label-width="120px" class="demo-dynamic" :rules="formRules" label-position='top'>
                            <el-form-item label="1.头雁人才学员选拔表(加盖公章)" prop="selectinfo">
                                <el-upload id="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="2.推荐信扫描件" prop="nominate">
                                <el-upload id="letterupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="letterSuccess" :on-remove="letterRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="letterfileList">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <!-- <div class="header">3.电子版照片
                        <span class="education">（证件照一张2寸蓝底、 个人商务照片一张、企业形象照片一张（可带公司Logo）</span>
                    </div> -->
                            <!-- <el-form-item label="3.电子版照片（证件照一张2寸蓝底、 个人商务照片一张、企业形象照片一张（可带公司Logo）" prop="peopleImg">
                                <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn" :action="actionUrl"
                                    :headers="header" :file-list="secondfileList">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>                                                   
                            <el-form-item label="4.报名视频" prop="video">
                                <el-upload v-if="thirdfileList.length==0" id="uploadmedia" accept=".mp4,.ogg,.flv,.avi,.wmv,.rmvb" list-type="picture-card"
                                    :on-success="thirdSuccessFn" :on-remove="thirdRemoveFn" :action="actionUrl" :file-list="thirdfileList"
                                    :headers="header">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <div v-else class="videobox">
                                    <video id="media" v-if="formData.video" :src="videoUrl+formData.video" controls width="320px" heigt="200px"></video>
                                    <span class="spanbox" @click="deleteVideo">
                                        <i class="el-icon-delete-solid videoicon" />
                                    </span>
                                </div>
                            </el-form-item>
                            <el-form-item label="5.其它文件上传" prop="file">
                                <el-upload multiple :on-success="handlefileSuccess" :on-remove="handlefileRemove" :action="actionUrl" :headers="header" :file-list="fileList">
                                    <i class="el-icon-upload upicon"></i>
                                </el-upload>
                            </el-form-item> -->
                            <div class="formBtnBox">
                                <el-button type="primary" @click="submitForm('formData')" class="submitBtn">提交</el-button>
                                <el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
                <div v-else class="submitSuccessBox">
                    <img src="@/assets/imgs/lead/success.png" class="img">
                    <div class="text1">
                        您已提交成功！
                    </div>
                    <div class="text2">
                        审核通过后《入学通知书》将会发送至您的消息中心，请注意查收！
                    </div>
                    <div class="btnbox">
                        确定
                    </div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
    props: {
        fileVisible: {
            type: Boolean,
            default: false
        }
    },
    // watch: {
    //     fileVisible(oldVal, newVal) {
    //         this.showFileVisible = this.fileVisible
    //     },
    // },
    data() {
        return {
            showFileVisible: true,
            active: 2,
            // 报名表单
            srcUrl: srcUrl,
            videoUrl: videoUrl,
            // 报名表单
            formData: {
                // video: '',//视频
                // file: '',//其他文件
                nominate: '',//推荐信
                // peopleImg: '',//人员照片
                selectinfo: '',//学员申请表
            },
            flag: false,
            formRules: {
                // video: [
                //     { required: true, message: '不能为空', trigger: 'change' }
                // ],
                // file: [
                //     { required: true, message: '不能为空', trigger: 'change' }
                // ],
                nominate: [
                    { required: true, message: '不能为空', trigger: 'change' }
                ],
                // peopleImg: [
                //     { required: true, message: '不能为空', trigger: 'change' }
                // ],
                selectinfo: [
                    { required: true, message: '不能为空', trigger: 'change' }
                ],
            },
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            header: null,
            imgfileList: [],
            letterfileList: [],
            secondfileList: [],
            thirdfileList: [],
            fileList: [],//其他文件
            studentTableUrl: '',
            recommendLetter:'',
        }

    },
    mounted() {
        this.getyetFormFn()
    },
    methods: {
        getyetFormFn() {
            httpService.GoosegetSingleLeaderTalen().then(res => {
                if (res.code == 200) {
                    this.studentTableUrl = res.result.studentTableUrl
                    this.recommendLetter= res.result.recommendLetter
                }
            })
        },
        // 选拔表
        downloadRecommendFn() {
            let Docurl = `http:${
                process.env.VUE_APP_WZ
                }${"/upload/download?session="}${this.studentTableUrl}`;
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            a.setAttribute("download", "");
            a.setAttribute("target", "_self");
            a.setAttribute("href", Docurl);
            a.click();
        },
        
        // 推荐信下载
        downloadFileFn() {
            let Docurl = `http:${
                process.env.VUE_APP_WZ
                }${"/upload/download?session="}${this.recommendLetter}`;
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            a.setAttribute("download", "");
            a.setAttribute("target", "_self");
            a.setAttribute("href", Docurl);
            a.click();
        },
        // 图片上传
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.imgfileList = fileList
                if (this.imgfileList.length > 0) {
                    document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 推荐信
        letterSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.letterfileList = fileList
                if (this.letterfileList.length > 0) {
                    document.querySelector('#letterupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        // 删除
        letterRemove(file, fileList) {
            this.letterfileList = []
            if (this.letterfileList.length == 0) {
                document.querySelector('#letterupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 第三个上传
        secondSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.secondfileList = fileList
            }
        },
        secondRemoveFn(file, fileList) {
            this.secondfileList = fileList
        },
        // 视频
        thirdSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.thirdfileList = fileList
                this.formData.video = res.result
                if (this.letterfileList.length > 0) {
                    document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        thirdRemoveFn(file, fileList) {
            this.thirdfileList = []
            if (this.letterfileList.length == 0) {
                document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        deleteVideo() {
            this.thirdfileList = []
            this.formData.video = ''
            if (this.letterfileList.length == 0) {
                document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 其他文件
        // 文件
        handlefileSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.fileList = fileList
            }
        },
        handlefileRemove(file, fileList) {
            this.fileList = fileList
        },
        // 报名表单
        submitForm(formName) {
            let selectinfo, nominate
            // video, applyDataUrl1 = [], applyDataUrl2 = []
            if (this.letterfileList.length != 0) {
                this.letterfileList.forEach(item => {
                    nominate = item.response.result
                })
            }
            if (this.imgfileList.length != 0) {
                this.imgfileList.forEach(item => {
                    selectinfo = item.response.result
                })
            }
            // // 电子照片
            // if (this.secondfileList.length != 0) {
            //     this.secondfileList.map(item => {
            //         if (item.response) {
            //             return applyDataUrl1.push(item.response.result)
            //         }
            //     })
            // }
            // // 视频
            // if (this.thirdfileList.length != 0) {
            //     this.thirdfileList.forEach(item => {
            //         video = item.response.result
            //     })
            // }
            // // 其他文件
            // if (this.fileList.length != 0) {
            //     this.fileList.map(item => {
            //         if (item.response) {
            //             return applyDataUrl2.push(item.response.result)
            //         }
            //     })
            // }

            if (!selectinfo || !nominate) {
                this.$message.error('请按要求上传所需文件图片');
                return
            }
            else {
                let data = {
                    selectinfo,
                    nominate,
                    // video,
                    // peopleImg: applyDataUrl1.join(','),
                    // file: applyDataUrl2.join(','),
                    status: 1,
                    auditResult: 0
                }
                httpService.GoosesubmitLeaderTalent(data).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: '领军人才文件提交成功',
                            type: 'success'
                        });
                        this.$destroy(this.$emit('changeShowFile', false))
                        // this.$emit('fileModal',false)
                        // if (!this.isCustom) this.$destroy() // 销毁当前组件
                    } else {
                        this.$message.error(res.message);
                    }
                })
            }
        },
        // 关闭表单
        offmodalFn() {
            // this.$emit('update:visible', false)
            // this.$emit('fileModal',false)
            this.$destroy(this.$emit('changeShowFile', false)) // 销毁当前组件
        },
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	/deep/.singupdialogcenter {
		// padding: 0px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		.stepsBox {
			width: 100%;
		}
		.textbox {
			width: 300px;
			display: flex;
			flex-direction: row;
			align-content: center;
			align-items: center;
			justify-content: space-between;
			width: 50%;
			margin: 20px auto 0 auto;
			font-size: 16px;
			color: #333333;

			.leftbox {
				display: flex;
				flex-direction: row;
				align-content: center;
				align-items: center;
				.imgbox {
					width: 30px;
					height: 30px;
				}
			}
			.downBox {
				width: 56px;
				text-align: center;
				line-height: 26px;
				height: 26px;
				background: #ffffff;
				border-radius: 13px 13px 13px 13px;
				color: #0e83fc;
				font-size: 14px;
				border: 1px solid #0e83fc;
				cursor: pointer;
			}
			// span,

			// .iconbox {
			// 	color: #448df7;
			// 	cursor: pointer;
			// }
			// .iconbox {
			// 	margin-left: 4px;
			// }
		}
		.singupForm {
			width: 50%;
			margin: 20px auto 0 auto;
			/deep/.el-upload--picture-card {
				width: 100px;
				height: 100px;
				line-height: 100px;
			}
			/deep/.el-form-item__label {
				padding: 0;
			}
			/deep/.el-form-item {
				margin-bottom: 10px;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 100px;
				height: 100px;
			}
			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				margin-top: 20px;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}

				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
			.upicon {
				font-size: 48px;
			}
			.videobox {
				width: 200px;
				height: 200px;
				display: flex;
				flex-direction: row;
				align-content: center;
				// position: relative;
				video {
					object-fit: fill;
				}
				.spanbox {
					// position: absolute;
					// top: 100px;
					// left: 50%;
					// transform: translateX(-50%);
					// width: 50px;
					// height: 50px;
					// text-align: center;
					// line-height: 50px;
					// border-radius: 50%;
					// background: rgb(238, 237, 237);
					margin-left: 10px;
					.videoicon {
						font-size: 20px;
						cursor: pointer;
					}
					&:hover {
						// background: rgb(179, 220, 247);
						color: #349cff;
					}
				}
			}
		}
		.submitSuccessBox {
			width: 60%;
			margin: 100px auto 0 auto;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			align-items: center;
			.img {
				width: 100px;
				height: 100px;
			}
			.text1 {
				font-size: 22px;
				font-weight: bold;
				color: #333333;
				margin: 12px 0 16px 0;
			}
			.text2 {
				font-size: 16px;
				color: #666666;
				line-height: 30px;
				margin-bottom: 120px;
			}
			.btnbox {
				width: 152px;
				height: 40px;
				background: #349cff;
				font-size: 14px;
				color: #ffffff;
				text-align: center;
				line-height: 40px;
			}
		}
	}
}
// 默认当前激活步骤显示的是黑色，这里修改显示为蓝色
::v-deep .el-step__head.is-process {
	color: #1890ff !important; // 圆圈中数字
	border-color: #1890ff !important; // 圆圈
}
::v-deep .el-step__title.is-process {
	color: #1890ff !important; // 圆圈下的标题文本
}
</style>


